module.exports = __webpack_public_path__ + "media/images/icons/outlined/bar-chart-d67a3afb0ca5e30f99b6f392effd3046.svg";